import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IconSizeDirective } from 'src/app/shared/directives/icon-size.directive';
export interface CompactNotification {
  date: Date;
  icon: string;
  id: number;
  metaData: string | undefined;
  seen: boolean;
  subtitle: string;
  title: string;
  emailSent: boolean;
}

@Component({
  selector: 'app-notification-compact',
  imports: [DatePipe, MatIconModule, IconSizeDirective],
  styleUrl: './notification-compact.component.scss',
  template: `
    <div
      class="wrapper"
      [class.seen]="isSeen()"
      (mouseenter)="isHovering.set(true)"
      (mouseleave)="isHovering.set(false)"
      (focusin)="isHovering.set(true)"
      (focusout)="isHovering.set(false)"
      tabindex="0"
    >
      <div>
        <div class="icon-wrapper" [class.flat]="!isSeen()">
          <mat-icon [svgIcon]="notification().icon" class="icon"></mat-icon>
        </div>
      </div>
      <div class="text-wrapper">
        <span class="title-text">{{ notification().title }}</span>
        <span>{{ notification().subtitle }}</span>

        <div class="footnote-wrapper">
          <span>{{ notification().date | date: 'd-MMM-y HH:mm' }}</span>
          @if (!!notification().metaData) {
            <span> - {{ notification().metaData }}</span>
          }
        </div>
      </div>
      @if (emailSent()) {
        <mat-icon svgIcon="email" class="email-icon"></mat-icon>
      }
      @if (!isSeen()) {
        <span class="unread-badge" [class.hovering]="isHovering()" aria-hidden="true">
          <mat-icon svgIcon="dot-mark" class="badge-default icon" />
          <span class="badge-fill" aria-hidden="true"></span>
        </span>
      }
    </div>
  `,

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationCompactComponent {
  readonly notification = input.required<CompactNotification>();

  readonly isHovering = signal(false);

  readonly isSeen = computed(() => !!this.notification().seen);

  readonly emailSent = computed(() => !!this.notification().emailSent);
}
